// src/pages/login/Login.js
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import styles from "./Login.module.css";
import { FaUser, FaLock, FaRobot, FaArrowLeft } from "react-icons/fa"; // Removed FaEnvelope, added FaUser

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState(""); // Changed from email to username
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    // Add your authentication logic here
    navigate("/dashboard");
  };

  return (
    <div className={styles.page}>
      {/* Animated Background Particles */}
      <div className={styles.particles}>
        {[...Array(15)].map((_, i) => (
          <div key={i} className={styles.particle}></div>
        ))}
      </div>

      {/* Floating Elements */}
      <div className={styles.floatingElement1}></div>
      <div className={styles.floatingElement2}></div>
      <div className={styles.floatingElement3}></div>

      {/* MAIN CONTAINER */}
      <div className={styles.loginContainer}>
        {/* LEFT SIDE - Modern Hero Section */}
        <div className={styles.left}>
          <div className={styles.heroOverlay}>
            <div className={styles.heroContent}>
              <div className={styles.logo}>
                {/* <FaRobot className={styles.logoIcon} /> */}
                {/* <span className={styles.logoText}>AI-MEBOT</span> */}
              </div>

              <h1 className={styles.heroTitle}>
                <span className={styles.gradientText}>Welcome Back</span>
                <br />
                To Your AI Assistant
              </h1>

              <p className={styles.heroSubtitle}>
                Access your personalized dashboard and continue your journey
                with intelligent automation and insights.
              </p>

              {/* <div className={styles.features}>
                <div className={styles.feature}>
                  <div className={styles.featureIcon}>🤖</div>
                  <span>Smart AI Assistant</span>
                </div>
                <div className={styles.feature}>
                  <div className={styles.featureIcon}>⚡</div>
                  <span>Real-time Analysis</span>
                </div>
                <div className={styles.feature}>
                  <div className={styles.featureIcon}>🔒</div>
                  <span>Secure Login</span>
                </div>
              </div> */}

              {/* <div className={styles.stats}>
                <div className={styles.stat}>
                  <h3>10K+</h3>
                  <p>Active Users</p>
                </div>
                <div className={styles.stat}>
                  <h3>99.9%</h3>
                  <p>Uptime</p>
                </div>
                <div className={styles.stat}>
                  <h3>24/7</h3>
                  <p>AI Support</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE - Login Form */}
        <div className={styles.right}>
          <div className={styles.loginCard}>
            <div className={styles.cardHeader}>
              <h2>Sign In to AI-MEBOT</h2>
              <p>Enter your credentials to access your account</p>
            </div>

            <form onSubmit={handleLogin} className={styles.form}>
              <div className={styles.inputGroup}>
                <div className={styles.inputIcon}>
                  <FaUser /> {/* Changed from FaEnvelope to FaUser */}
                </div>
                <input
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className={styles.inputField}
                />
                <label className={styles.inputLabel}>Username</label>{" "}
                {/* Updated label */}
              </div>

              <div className={styles.inputGroup}>
                <div className={styles.inputIcon}>
                  <FaLock />
                </div>
                <input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className={styles.inputField}
                />
                <label className={styles.inputLabel}>Password</label>
              </div>

              <div className={styles.options}>
                {/* <label className={styles.rememberMe}>
                  <input type="checkbox" />
                  <span>Remember me</span>
                </label> */}
                {/* <Link to="/forgot-password" className={styles.forgotPassword}>
                  Forgot Password?
                </Link> */}
              </div>

              <button type="submit" className={styles.loginBtn}>
                <span>Sign In</span>
                <div className={styles.btnArrow}>→</div>
              </button>

              <Link to="/" className={styles.backBtn}>
                <FaArrowLeft />
                Back to Home
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;